import React from "react";

const getBackgroundColor = (color, disabled) => {
  if (color === "secondary") {
    return disabled ? "bg-dupontBlue dark:bg-darkElevated opacity-[80%]" : "bg-dupontBlue dark:bg-darkElevated";
  }

  return disabled ? "bg-dupontGold opacity-[60%]" : "bg-dupontGold";
};

const getTextColor = (color, disabled) => {
  if (color === "secondary") {
    return disabled ? "text-[#757575]" : "text-white";
  }
  return "text-white";
};

const getLoadingColor = (color) => {
  if (color === "secondary") {
    return "border-dupontGold";
  }
  return "border-white";
};

function Button({
  children,
  onClick = undefined,
  disabled = false,
  className = "",
  color = "primary",
  loadingText = undefined,
}) {
  const handleClick = (event) => {
    if (!disabled && onClick) {
      onClick(event);
    }
  };

  const baseClassName =
    className ||
    "inline-block rounded-full px-[16px] py-[12px] w-fit h-fit text-center";

  const renderButtonContent = () => {
    if (loadingText) {
      return (
        <span className="flex flex-row justify-center items-center gap-x-[10px]">
          <span
            className={`block text-sm font-medium whitespace-nowrap ${getTextColor(
              color,
              disabled
            )}`}
          >
            {loadingText}
          </span>
          <span
            className={`block rounded-full animate-spin w-[20px] h-[20px] border-[6px] ${getLoadingColor(
              color
            )} border-t-transparent border-b-transparent`}
          />
        </span>
      );
    }
    return (
      <span
        className={`block text-sm font-medium whitespace-nowrap ${getTextColor(
          color,
          disabled
        )}`}
      >
        {children}
      </span>
    );
  };

  // A real <button>, so it can be reached with Tab and pressed with Enter or
  // Space, and a screen reader says "button" (and "dimmed" when disabled). It
  // looks as the old clickable <div> did: the inner <div>s became <span>s set
  // to display the same way, since a <button> may only hold inline content.
  // type="button" so it never submits a form it happens to sit in.
  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      data-testid="button"
      className={`${baseClassName} ${getBackgroundColor(color, disabled)} ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      {renderButtonContent()}
    </button>
  );
}

export default Button;
